import { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import Captcha from "demos-react-captcha";
import Select from "react-select";
import InputMask from "react-input-mask";

import API from "../../../../api/baseUrl";
import { serialize, original } from "../../../../functions/helper";
import config from "../../../../config.json";
import { enDate, faDate } from "../../../../functions/date";
import weekApi from "../../../../api/week";
import Loading from "../../../../components/loading";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const dateMask = {
  mask: "9999/99/99",
  maskChar: "_",
  alwaysShowMask: false,
  formatChars: {
    9: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]",
  },
  permanents: [2, 5],
};

export default function FastVisitInfo() {
  const history = useHistory();

  const Login_User_Token = localStorage.getItem("user_login_token");
  const Login_User_cp = localStorage.getItem("user_login_cp");

  const { state } = useLocation();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!state?.nationalCode || !state?.phoneNumber) history.push("/");
    else fetchServiceData();
  }, []);

  const fetchServiceData = async () => {
    try {
      const resService2 = await API.post(
        serialize({
          id: 1708,
          sp_param: `'${Login_User_Token}','${Login_User_cp}','0','0','machine_nm','machine_ip','machine_ip'`,
          Login_User_Token,
          Login_User_cp,
        })
      );
      setList(original(resService2.data, false));
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleRedirect = () => {
    history.push({
      pathname: "/visit/insert",
      state,
    });
  };

  return (
    <div
      className="fast-visit-page"
      style={{
        background: `linear-gradient(45deg,${
          config.auth_back_color_1 ? config.auth_back_color_1 : "rgba(86, 0, 110, 1)"
        } 10%,${config.auth_back_color_2 ? config.auth_back_color_2 : "rgba(33, 150, 243, 1)"} 100%)`,
      }}
    >
      <div className="fast-visit-page__box">
        <h2 className="fast-visit-page__title">{config.fast_visit_info ? config.fast_visit_info : "insert visit"}</h2>

        <div className="info">
          <table className="table">
            <tbody>
              {list.map((item, index) => (
                <tr key={index}>
                  <td>{item.cell_value}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button type="button" className="fast-visit-page__form_btn" onClick={handleRedirect}>
            {config.fast_visit_info_button_text ? config.fast_visit_info_button_text : "submit"}
          </button>
        </div>
        <div className="fast-visit-page__form_links">
          <Link to={{ pathname: "/" }}>بازگشت به لاگین</Link>
        </div>

        <div className="fast-visit-page__box_footer">
          <span>{enDate}</span>
        </div>
      </div>

      {loading && <Loading />}
    </div>
  );
}
